import { FastCalculatorListType, useParticularContext } from "@bundles/parts/components/PureList/ContextProviders/Particular/ParticularContext"
import { useMemo } from "react"
import { FastCalculatorArticleData } from "../../../models"
import { emptyArr, emptyFunc } from "../../../helpers"

export function useFastCalculatorList(): FastCalculatorArticleData {
    const contextProvider = useParticularContext<FastCalculatorListType>()
    const { genarts, articles } = contextProvider ?? {}

    return useMemo(
        () => ({
            requestStatus: "success",
            isEnabled: !!genarts,
            isLoading: false,
            isLoaded: true,
            isSuccess: true,
            isFailed: false,
            articles: articles ?? emptyArr,
            genarts: genarts ?? emptyArr,
            isFetchingNextPage: false,
            pageCount: 1,
            articleCount: articles?.length ?? 0,
            supplierIds: emptyArr,
            productGroupIds: emptyArr,
            loadNextPage: emptyFunc,
            hasNextPage: false,
        }),
        [articles, genarts]
    )
}
